module.exports = __webpack_public_path__ + "img/news-6.527a835d.jpg";